import React from 'react';

import twMerge from 'utilities/src/twMerge';

export type Talent = {
  name: string;
  role: string;
  image: {
    url: string;
    alt: string;
  };
};

export type Link = {
  label: string;
  href: string;
};

export type Quote = {
  quote: string;
  author: {
    name: string;
    company: string;
    image: string;
  };
  link: {
    label: string;
    href: string;
  };
};

export type HiringEngineers = {
  title: string;
  description: string;
  talents: Talent[];
  links: Link[];
};

export type WidgetsType = {
  hiringEngineers: HiringEngineers;
  relatedServices: {
    title: string;
  };
  quote: Quote;
  relatedArticles: {
    title: string;
  };
};

/**
 * Widgets Props
 */

export type WidgetsProps = {
  children: React.ReactNode;
  className?: string;
};

/**
 * Widgets Component
 */

export default function Widgets({ children, className }: WidgetsProps) {
  return (
    <div className={twMerge('mdL:min-w-[17.5rem] flex flex-col gap-8 md:min-w-64', className)}>{children}</div>
  );
}
